import { useTheme } from '@ethings/ui-toolkit';
import { FC, JSX, ReactNode, useEffect, useState } from 'react';
import { SisenseContextProvider, ThemeProvider as SisenseThemeProvider } from 'sisense-sdk-ui-next';
import { useAuthenticated } from '../../auth';
import { useConfig } from '../../hooks';
import { createSisenseTheme, fetchWatToken, getSisenseLanguageCode } from '../../util';
import { useBoolFlag } from '../flags';
import { MiddleSpinner } from '../middle-spinner';

interface SisenseWrapperProps {
  children: ReactNode;
}

export const SisenseWrapper: FC<SisenseWrapperProps> = ({ children }): JSX.Element => {
  const { sisense } = useConfig();
  const { restClient } = useAuthenticated();
  const [error, setError] = useState<Error>();
  const [wat, setWat] = useState<string>();
  const composeSdkEnabled = useBoolFlag('portals-sisense-compose-sdk-feature');
  const theme = useTheme();
  const sisenseTheme = createSisenseTheme(theme);

  useEffect(() => {
    if (composeSdkEnabled && !wat) {
      fetchWatToken(restClient).then(({ wat }) => {
        setWat(wat);
      }).catch((err: Error) => {
        console.error('Failed to fetch Sisense WAT token:', err);
        setError(err);
      });
    }
  }, [restClient, composeSdkEnabled, wat]);

  if (!composeSdkEnabled || !sisense?.baseUrl) {
    return <>{children}</>;
  }

  if (error) {
    return <></>;
  }

  if (!wat) {
    return <MiddleSpinner />;
  }

  return (
    <SisenseContextProvider onError={setError} url={sisense.baseUrl} wat={wat} appConfig={{ locale: { code: getSisenseLanguageCode() } }}>
      <SisenseThemeProvider theme={sisenseTheme}>
        {children}
      </SisenseThemeProvider>
    </SisenseContextProvider>
  );
};
